enum CampusRegion {
    UnitedStates = 1,
}

export default CampusRegion;
